import AbstractAnimation from "./abstract-animation";
import {Sine} from "gsap";

export default class CloseDesktopNavigation extends AbstractAnimation
{
    create(): any {
        let targetHeight = 0;
        let $overlay = $('.l-overlay');
        // let targetHeight = this.$element.height() * 0.5;
        return this
            .timeline
            .to($overlay, { duration: 0.2, opacity: 0 }, 0)
            .to(this.$element, { duration: 0.4, height: targetHeight, ease: 'Power2.easeOut' }, 0)
            // .to(this.$element, 0.1, { opacity: 0, ease: 'sine.easeOut' }, 0)
            .call(
                () => {
                    $overlay.removeClass('l-overlay--active');
                    this
                        .$element
                        .attr('hidden', 'hidden')
                        .attr('aria-expanded', 'false');
                }
            )
            .set(this.$element, { clearProps: 'opacity,height' })
        ;
    }
}